import React, { useState } from "react";
import Input from "./Input";
import Button from "./Button";
import Title from "./Title";
import { QuestionBank } from './Data/QuestionBank';
import { useStore } from "../store";
import { size } from "../utlis/device";
import styled from "styled-components";

const QuestionStyle = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    z-index: 999999999999;
    position: relative;
    margin-top: -20px;
    width: 100%;

  /* right: 0; */

  @media (max-width: ${size.tablet}) {

  }
`
const QuestionContainer = styled.div `
  /* width: 50%;
  padding: 20px 10px; */
`

const Questions = () => {
    const [color, setColor] = useState("black")
    let rotation = useStore((state) => state.rotation)
    const question = useStore((state) => state.question)
    let [score, setScore] = useState(0);
    const me = useStore((state) => state.me)
    const increaseRotation = useStore((state) => state.increaseRotation)
    const decreaseRotation = useStore((state) => state.decreaseRotation)
    const clearRotation = useStore((state) => state.clearRotation)
    const increaseQuestion = useStore((state) => state.increaseQuestion)

    const agree = (e) => {
      e.preventDefault();
        if (rotation === 0) {
          setColor("#037a73")
          increaseRotation()
        } 
        else if (color === "#037a73") {
          setColor("black")
          decreaseRotation()
        }
        else if (color === "#d64f40") {
          increaseRotation()
          increaseRotation()
          setColor("#037a73")
        }
    }

    const disagree = (e) => {
      e.preventDefault();
        if (rotation === 0) {
          setColor("#d64f40")
          decreaseRotation()
        } 
        else if (color === "#d64f40") {
          setColor("black")
          increaseRotation()
        }
        else if (color === "#037a73") {
          decreaseRotation()
          decreaseRotation()
          setColor("#d64f40")
        }
    }

    const nextBtn = () => {
      increaseQuestion()
      setColor("black")
      setScore(rotation += score)
      
    }

    const clear = async () => {
      await nextBtn()
      clearRotation()
      if (score >= 0) {
          me.isNice = true
          me.isNaughty = false
      } else if  (score < 0) {
          me.isNaughty = true
          me.isNice = false
      }
    }

    return (
      <div>
        <QuestionStyle>
        { question <= 4 &&
          <div>

              {/* <Label htmlFor="checkbox"> </Label> */}
              <QuestionContainer>
                  <Input name={"checkbox0"} type={"button"} placeholder={"Example question"} value={QuestionBank[question].q}  backgroundColor={color}/>
              </QuestionContainer>
              <div> 
                <Button backgroundColor={"#037a73"} value={"yes"} onClick={(e) => agree(e)}>Yes</Button>
                <Button backgroundColor={"#d64f40"} value={"no"} onClick={(e) => disagree(e)}>No</Button>
                </div>
           </div>     
        }
        { question === 5 &&
          <QuestionStyle>
            <Title text="Santa’s made up his mind click below to see what list you’re on!"/>
          </QuestionStyle>
        }
          <Button onClick={clear} backgroundColor={"#deb263"}>Next</Button>
        </QuestionStyle>
      </div>
        
    )
}

export default Questions;
